import { onScroll } from '../lib/scroll';

// Highlight the table-of-contents entry for the heading currently being read.
export function initToc(): void {
  const toc = document.querySelector<HTMLElement>('[data-toc]');
  if (!toc) return;

  const links = Array.from(toc.querySelectorAll<HTMLAnchorElement>('a[href^="#"]'));
  const headings = links
    .map((link) => document.querySelector<HTMLElement>(link.getAttribute('href') || ''))
    .filter((el): el is HTMLElement => Boolean(el));

  if (!headings.length) return;

  onScroll(() => {
    let currentId = headings[0].id;
    headings.forEach((heading) => {
      if (heading.getBoundingClientRect().top < 140) currentId = heading.id;
    });

    links.forEach((link) => {
      link.classList.toggle('is-active', link.getAttribute('href') === `#${currentId}`);
    });
  });
}
